
/**
 * @ENV
 */
export default {
    BUNDLE_ELEMENT: 'partials-bundle',
    TEMPLATE_ELEMENT: 'template',
        TEMPLATE_NAMESPACE_ATTR: 'name',
            SLOT_REFERENCE_ATTR: 'partials-slot',
    TEMPLATE_REFERENCE_ATTR: 'template',
        SLOT_ELEMENT: 'partials-slot',
            SLOT_NAME_ATTR: 'name',
    KEY_VAL_ATTR: [],
    LIST_ATTR: [],
    SLOTS_INERT_CONTEXTS: ['template'],
    NO_INHERIT_ATTR: ['nocompose', 'name', 'template'],
};
